import script from "./PatientGroupSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./PatientGroupSection.vue?vue&type=script&lang=ts&setup=true"

import "./PatientGroupSection.vue?vue&type=style&index=0&id=472b64df&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-472b64df"]])

export default __exports__